import { useEffect, useState } from 'react'

const LANG_KEY = 'exis-lang'
const DEFAULT_LANG = 'UA'

const locales = {
  EN: () => import('../../locales/en/en.json'),
  UA: () => import('../../locales/ua/ua.json'),
}

function getStoredLang() {
  if (typeof window === 'undefined') return DEFAULT_LANG
  const stored = localStorage.getItem(LANG_KEY)
  return stored === 'UA' ? 'UA' : DEFAULT_LANG
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang)
  window.dispatchEvent(new CustomEvent('exis-lang-change', { detail: lang }))
}

function useLang() {
  const [lang, setLangState] = useState(getStoredLang())
  const [messages, setMessages] = useState(null)

  useEffect(() => {
    locales[lang]().then((module) => setMessages(module.default))
  }, [lang])

  useEffect(() => {
    const handler = (e) => setLangState(e.detail)
    window.addEventListener('exis-lang-change', handler)
    return () => window.removeEventListener('exis-lang-change', handler)
  }, [])

  const t = (path, fallback = '') => {
    if (!messages) return fallback
    const keys = path.split('.')
    let value = messages
    for (const key of keys) {
      value = value?.[key]
      if (value === undefined) return fallback
    }
    return value
  }

  return { lang, t, ready: messages !== null }
}

export default useLang
export { getStoredLang }
